@keyframes dots0123 {
  0%   { content: ''; }
  33%  { content: '.'; }
  66%  { content: '..'; }
  100% { content: '...'; }
}

.status {
  word-break: break-word;
  padding-block: var(--inner-padding);

  @media (max-width: 800px) {
    padding: var(--inner-padding);
  }

  &.loading > div:after {
    animation: dots0123 1s infinite;
    content: '';
  }
}

